(function () {

  // Showboat's collection template uses a custom grid (div.product-grid-custom
  // of a.pc-card), not Dawn's #product-grid. Sold-out cards are identified by
  // their "SOLD OUT" badge (span.pc-card__badge). Dawn selectors kept as a
  // fallback in case a page still renders the stock grid.
  function sortSoldOutToEnd() {
    const grid =
      document.querySelector('.product-grid-custom') ||
      document.querySelector('#product-grid');
    if (!grid) return;

    const isSoldOut = el =>
      el.hasAttribute('data-sold-out') ||
      el.querySelector('[data-sold-out]') !== null ||
      Array.from(el.querySelectorAll('.pc-card__badge, .badge')).some(b =>
        /sold\s*out/i.test(b.textContent)
      );

    const items = Array.from(grid.children);
    const inStock = items.filter(el => !isSoldOut(el));
    const outOfStock = items.filter(isSoldOut);

    if (outOfStock.length === 0 || inStock.length === 0) return;

    // Already ordered (no sold-out card before an in-stock one)? Do nothing.
    // This also stops the observer from re-triggering on our own reorder.
    const lastInStockIndex = items.indexOf(inStock[inStock.length - 1]);
    const firstSoldOutIndex = items.indexOf(outOfStock[0]);
    if (firstSoldOutIndex > lastInStockIndex) return;

    inStock.concat(outOfStock).forEach(el => grid.appendChild(el));
  }

  // Filters/sorting on this store are full page reloads, so running once per
  // load is enough. Script is deferred, so the DOM is ready here.
  sortSoldOutToEnd();

  // Insurance: if an app or future change ever swaps the grid via AJAX
  // (infinite scroll, ajax facets), re-sort when product cards are injected.
  const grid = document.querySelector('.product-grid-custom, #product-grid');
  const watchTarget = grid ? grid.parentElement : null;
  if (!watchTarget) return;

  let scheduled = false;
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        if (!scheduled) {
          scheduled = true;
          // Batch bursts of mutations into one sort per frame.
          requestAnimationFrame(function () {
            scheduled = false;
            sortSoldOutToEnd();
          });
        }
        break;
      }
    }
  });

  observer.observe(watchTarget, { childList: true, subtree: true });

})();
